function rechargeMutationObserver(runEvents) {
  const targetNode = document.querySelector("product-form");
  const config = { attributes: true, childList: true, subtree: true };

  if(!targetNode) return;

  const callback = (mutationList, observer) => {

    const filteredMutation = mutationList.filter((mutation) => mutation.target.matches("div.rc-container-wrapper.rc_container_wrapper"));

    //Only run callback if mutation is recharge
    if(filteredMutation && filteredMutation.length > 0) {

      //Re-run event listeners on recharge app mutation
      runEvents();

      //Disconnect after the first mutation
      observer.disconnect();

      //Reconnect the observer after a brief delay
      setTimeout(() => {
        observer.observe(targetNode, {
          childList: true,
          subtree: true,
          attributes: true
        });
      }, 150);
    }
  };

  const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
}

//Update ATC button price to reflect recharge discount
function priceMutationObserver(updateATCButtonPrice) {
  const targetNode = document.querySelector(".product__info-container");
  const config = { attributes: true, childList: true, subtree: true };

  if(!targetNode) return;

  const callback = (mutationList, observer) => {

    const filteredMutation = mutationList.filter((mutation) => mutation.target.matches("div.price__regular"));

    if(filteredMutation) {

      //Allow price to be updated by recharge first
      setTimeout(() => {

        //Run update price function
        updateATCButtonPrice(filteredMutation);

        observer.disconnect();

        observer.observe(targetNode, {
          childList: true,
          subtree: true,
          attributes: true
        });
      }, 250);
    }
  };

  const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
}